export default "__VITE_ASSET__J5QPccH0__"